var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppSettings = function SvgAppSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 16H2.75l-.102.007A.75.75 0 0 0 2.75 17.5h18.5l.102-.007A.75.75 0 0 0 21.25 16ZM21.25 6.5H2.75l-.102.007A.75.75 0 0 0 2.75 8h18.5l.102-.007A.75.75 0 0 0 21.25 6.5Z",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.913 16a3.251 3.251 0 0 0-6.326 0c-.054.334-.13 1.101 0 1.5a3.251 3.251 0 0 0 6.326 0c.13-.399.054-1.166 0-1.5ZM18.413 6.5a3.251 3.251 0 0 0-6.326 0c-.054.334-.13 1.101 0 1.5a3.251 3.251 0 0 0 6.326 0c.13-.399.054-1.166 0-1.5Z",
    fill: "#999"
  })));
};
export default SvgAppSettings;